import { useState } from 'react';
import SelectElement from '../../../../../components/forms/SelectElement';
import Modal from '../../../../../components/modals/Modal';
import { testLabelOptions } from '../../../../../data/option-objects/examOptions';
import EditCard from '../EditCard';
import type {
	ExamLabel,
	Question as IQuestion
} from '../../../../../data/interface-question';
import type { QuestionBankID } from '../../../../../data/interface-question-bank';

interface QuestionProps {
	question: IQuestion;
	onUpdate: (
		questionID: string,
		key: string,
		newValue: any
	) => Promise<IQuestion | null>;
}
const ViewEditTestLabel = ({ question, onUpdate }: QuestionProps) => {
	const questionBankID = localStorage.getItem(
		'questionBankID'
	) as QuestionBankID;
	const [edit, setEdit] = useState(false);
	const [source, setSource] = useState<string>(question.source);

	const handleUpdate = () => {
		onUpdate(question.id, 'source', source)
			.then(() => setEdit(false))
			.catch((error) => console.error('Error updating question:', error));
	};

	return (
		<>
			<EditCard label='Question Source' onEdit={setEdit}>
				{question.source === undefined ? (
					<p>No hay fuente para mostrar</p>
				) : (
					<p>{question.source}</p>
				)}
			</EditCard>

			<Modal
				actionBtnText='Actualizar'
				handleAction={handleUpdate}
				headline='Actualiza la Pregunta'
				isOpen={edit}
				onClose={() => setEdit(false)}
				showCloseBtn={true}>
				<SelectElement
					defaultOption={`- Elige Uno: ${questionBankID} o prepmed -`}
					id='source'
					icon='ballot'
					iconFam='material-icons'
					label='Elige un tipo de examen'
					options={
						questionBankID === 'enurm'
							? testLabelOptions.enurmAdmin
							: questionBankID == 'maxilofacial'
							? testLabelOptions.maxilofacialAdmin
							: questionBankID === 'dermatología'
							? testLabelOptions.dermatología
							: questionBankID === 'prep+'
							? testLabelOptions['prep+']
							: testLabelOptions.enurm
					}
					value={source}
					handleChange={(v) => {
						setSource(v as ExamLabel);
					}}
				/>
			</Modal>
		</>
	);
};
export default ViewEditTestLabel;
